import useApi from "../..";

const useJobApi = () => {
    const { request } = useApi(); 
      //provider
    const getProviderJobsRequests = (limit, offset, status) => request(`/booking/my-request?limit=${limit}&offset=${offset}&status=${status}`, 'GET', null)
    const getProviderJobRequestDetails = (jobReqId) => request(`/booking/${jobReqId}/my-request-details`, 'GET', null)
    const submitQuoteAsSP = (payload) => request(`/quote`, 'POST', payload)
    const acceptRejectJobRequest = (bookingId, payload) => request(`/booking/${bookingId}`, 'PATCH', payload)
    const completeJobRequest = (jobId) => request(`/booking/${jobId}/complete`, 'PATCH', null)
    const amendJob = (payload) => request('/booking/amendment', 'POST', payload)
    // const getJobsByDate = (limit, offset, bkType, bkStatus, startDate, endDate) => request(`/booking/my-job?limit=${limit}&offset=${offset}&type=${bkType}&status=${bkStatus}&startDate=${startDate}&endDate=${endDate}`, 'GET', null)
    const getJobsByDate = (limit, offset, bkStatus, startDate, endDate) => request(`/booking/my-job?limit=${limit}&offset=${offset}&status=${bkStatus}&startDate=${startDate}&endDate=${endDate}`, 'GET', null)
    const getJobListing = (limit, offset) => request(`/quote/job-listing-by-country?limit=${limit}&offset=${offset}`, 'GET', null)


    return { 
        getProviderJobsRequests,
        getProviderJobRequestDetails,
        submitQuoteAsSP,
        acceptRejectJobRequest,
        completeJobRequest,
        amendJob,
        getJobsByDate,
        getJobListing
    };
};

export default useJobApi;
